import React from 'react';
import { points } from '../utils/format';
interface PointsBadgeProps {
  actualBps: number;
  isShort: boolean;
  size?: 'sm' | 'lg';
}
export function PointsBadge({
  actualBps,
  isShort,
  size = 'sm'
}: PointsBadgeProps) {
  const tone = isShort ? 'bg-short-soft text-short border-short/20' : 'bg-clear-soft text-clear border-clear/20';
  return <span className={`inline-flex items-baseline gap-1.5 rounded border font-mono tabular-nums ${tone} ${size === 'lg' ? 'px-2.5 py-1 text-base' : 'px-2 py-0.5 text-xs'}`} data-id="element-101" data-mp="cno7xa8rfybc">
      {points(actualBps)}
      <span className="font-sans text-[10px] font-semibold uppercase tracking-wider" data-id="element-102" data-mp="10awdlta3p9dw">
        {isShort ? 'Short' : 'Full'}
      </span>
    </span>;
}